// 统计模块

//首页统计数据
function statisticsData(data) {
  return new Promise(resolve => {
    $.ajax({
      type: "post",
      url: APIB,
      data: { action: "edit", pagename: 'bGetEntJobDataCount', userid: Cookies.get("userid-b"), QueryStr: JSON.stringify(data) },
      dataType: "json",
      success: res => {
        if (res) {
          try {
            const jsonRes = JSON.parse(res);
            if (jsonRes.status == "ok" && jsonRes.msg) {
              resolve(jsonRes.msg.jobCountList);
            } else {
              resolve(false);
            }
          } catch (e) {
            resolve(false);
          }
        } else {
          resolve(false);
        }
      }
    });
  });
}

//刷新地图坐标点
function refreshPoints() {
  return new Promise(resolve => {
    $.ajax({
      type: "post",
      url: APIB,
      dataType: "json",
      data: { action: "edit", userid: Cookies.get("userid-b"), pagename: "bResetPointInfo" },
      success: res => {
        let str = JSON.parse(res);
        resolve(str.status == "ok" ? true : false);
      }
    });
  });
}

//清除发布职位的缓存
function clearJobCache() {
  return new Promise(resolve => {
    $.ajax({
      type: "post",
      url: APIB,
      dataType: "json",
      data: { action: "edit", userid: Cookies.get("userid-b"), pagename: "bResetJobStatusRedis" },
      success: res => {
        let str = JSON.parse(res);
        resolve(str.status == "ok" ? true : false);
      }
    });
  });
}

export default {
  statisticsData,
  refreshPoints,
  clearJobCache
};
